import { render, staticRenderFns } from "./search-input.component.vue?vue&type=template&id=3ec0fd1e"
import script from "./search-input.component.vue?vue&type=script&lang=js"
export * from "./search-input.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports